import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "section content-container" }
const _hoisted_3 = { class: "container is-fluid" }
const _hoisted_4 = { class: "intents-charts" }
const _hoisted_5 = { class: "columns is-desktop" }
const _hoisted_6 = { class: "column is-two-thirds-desktop" }
const _hoisted_7 = { class: "columns" }
const _hoisted_8 = { class: "column is-half" }
const _hoisted_9 = { class: "island" }
const _hoisted_10 = { class: "column is-half" }
const _hoisted_11 = { class: "island" }
const _hoisted_12 = { class: "column is-one-third-desktop" }
const _hoisted_13 = { class: "island" }
const _hoisted_14 = { class: "columns" }
const _hoisted_15 = { class: "column is-full" }
const _hoisted_16 = { class: "tall island with-labels" }
const _hoisted_17 = { class: "columns" }
const _hoisted_18 = { class: "column is-full" }
const _hoisted_19 = { class: "tall island with-labels" }
const _hoisted_20 = { class: "columns" }
const _hoisted_21 = { class: "column is-full" }
const _hoisted_22 = { class: "tall island with-labels" }

import { Data } from '@/features/reports/models';
import { nlpReportApi } from '@/features/reports/services';
import DoughnutChart from '../components/chartjs/DoughnutChart.vue';
import HorizontalThresholdBarChart from '../components/chartjs/HorizontalThresholdBarChart.vue';
import LineChart from '../components/chartjs/LineChart.vue';
import Report from '../components/Report.vue';
import { SET_REPORT_LOADING } from '@/store/reports/mutationTypes';
import { useStore } from 'vuex';
import { computed, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IntentsReports',
  setup(__props) {

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const selectedDateOption = computed(() => store.getters.selectedDateOption);

const setLoading = (loading: boolean) => store.commit(SET_REPORT_LOADING, loading);

const mostPopularTotals = ref<Data>({ series: [], scale: { labels: [], title: '' } });
const lowestConfidenceTotals = ref<Data>({ series: [], scale: { labels: [], title: '' } });
const highestConfidenceTotals = ref<Data>({ series: [], scale: { labels: [], title: '' } });

const mostPopularTrends = ref<Data>({ series: [], scale: { labels: [], title: '' } });
const lowestConfidenceTrends = ref<Data>({ series: [], scale: { labels: [], title: '' } });

const highestConfidenceTrends = ref<Data>({ series: [], scale: { labels: [], title: '' } });
const averageConfidence = ref(0);

const loadingError = ref(false);
const loadedData = ref(false);

const highestLabelValues = ref<Map<string, string>>(new Map());
const lowestLabelValues = ref<Map<string, string>>(new Map());

watch(
  selectedDateOption,
  async (filter, previous) => {
    if (filter && filter === previous) {
      return;
    }

    await renderReportData();
  },
  { immediate: true },
);

async function renderReportData() {
  if (!isReportCriterionValid()) {
    return;
  }
  loadedData.value = false;
  loadingError.value = false;
  setLoading(true);

  try {
    await loadReportData();
    loadedData.value = true;
  } catch {
    loadingError.value = true;
  } finally {
    setLoading(false);
  }
}

function isReportCriterionValid(): boolean {
  return !!selectedDateOption.value;
}

async function loadReportData(): Promise<void> {
  const filterRange = selectedDateOption.value.getDateRange();
  const responseData = await nlpReportApi.get(currentWorkspace.value.id, {
    startDate: filterRange.start,
    endDate: filterRange.end,
    grouping: selectedDateOption.value.group,
  });

  mostPopularTotals.value = responseData.mostPopularTotalsReport;
  lowestConfidenceTotals.value = responseData.lowestConfidenceTotalsReport;
  highestConfidenceTotals.value = responseData.highestConfidenceTotalsReport;
  averageConfidence.value = responseData.confidenceAverage;
  highestConfidenceTrends.value = responseData.highestConfidenceTrendReport;

  mostPopularTrends.value = responseData.mostPopularTrendReport;
  lowestConfidenceTrends.value = responseData.lowestConfidenceTrendReport;

  setAverageLabels();
}

function isDataEmpty(data: Data) {
  if (!data) {
    return false;
  }
  return data.scale.labels.length < 1 || data.series.length < 1;
}

function setAverageLabels() {
  setLabels(highestConfidenceTotals.value, highestLabelValues.value);
  setLabels(lowestConfidenceTotals.value, lowestLabelValues.value);
}

function setLabels(data: Data, labels: Map<string, string>) {
  if (!isDataEmpty(data)) {
    data.series[0].data.forEach((average, index) => {
      const roundedAverage = Math.round(average * 1000) / 1000;
      labels.set(data.scale.labels[index], roundedAverage.toString());
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(Report, {
                      title: "Most Popular",
                      class: "totals-doughnut-chart",
                      dataEmpty: isDataEmpty(mostPopularTotals.value),
                      loadedData: loadedData.value,
                      loadingError: loadingError.value,
                      "no-labels": ""
                    }, {
                      chart: _withCtx(({ reportId }) => [
                        _createVNode(DoughnutChart, {
                          class: "chart",
                          title: "Total",
                          data: mostPopularTotals.value,
                          "report-id": "reportId"
                        }, null, 8, ["data"])
                      ]),
                      _: 1
                    }, 8, ["dataEmpty", "loadedData", "loadingError"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(Report, {
                      title: "Lowest Confidence",
                      tooltipText: "Shows the average score of each intent for the selected time period against the average score of all intents",
                      dataEmpty: isDataEmpty(lowestConfidenceTotals.value),
                      loadedData: loadedData.value,
                      loadingError: loadingError.value,
                      "no-labels": ""
                    }, {
                      chart: _withCtx(({ reportId }) => [
                        _createVNode(HorizontalThresholdBarChart, {
                          class: "chart",
                          data: lowestConfidenceTotals.value,
                          "threshold-data": averageConfidence.value,
                          "order-asc": true,
                          "bar-colour": "#FF6666",
                          "threshold-line-colour": "#E6C300"
                        }, null, 8, ["data", "threshold-data"])
                      ]),
                      _: 1
                    }, 8, ["dataEmpty", "loadedData", "loadingError"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(Report, {
                  title: "Highest Confidence",
                  tooltipText: "Shows the average score of each intent for the selected time period against the average score of all intents",
                  dataEmpty: isDataEmpty(highestConfidenceTotals.value),
                  loadedData: loadedData.value,
                  loadingError: loadingError.value,
                  "no-labels": ""
                }, {
                  chart: _withCtx(({ reportId }) => [
                    _createVNode(HorizontalThresholdBarChart, {
                      class: "chart",
                      data: highestConfidenceTotals.value,
                      "threshold-data": averageConfidence.value,
                      "order-asc": false,
                      "bar-colour": "#FF6666",
                      "threshold-line-colour": "#E6C300"
                    }, null, 8, ["data", "threshold-data"])
                  ]),
                  _: 1
                }, 8, ["dataEmpty", "loadedData", "loadingError"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(Report, {
                  title: "Most Popular Trend",
                  dataEmpty: isDataEmpty(mostPopularTrends.value),
                  loadedData: loadedData.value,
                  loadingError: loadingError.value,
                  tooltipText: "A trend showing the most popular intents over time"
                }, {
                  chart: _withCtx(({ reportId }) => [
                    _createVNode(LineChart, {
                      class: "chart",
                      reportId: reportId,
                      fill: false,
                      data: mostPopularTrends.value
                    }, null, 8, ["reportId", "data"])
                  ]),
                  _: 1
                }, 8, ["dataEmpty", "loadedData", "loadingError"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(Report, {
                  title: "Lowest Confidence Trend",
                  dataEmpty: isDataEmpty(lowestConfidenceTrends.value),
                  loadedData: loadedData.value,
                  loadingError: loadingError.value,
                  tooltipText: "A trend showing the average confidence score of the lowest rated intents over time"
                }, {
                  chart: _withCtx(({ reportId }) => [
                    _createVNode(LineChart, {
                      class: "chart",
                      reportId: reportId,
                      fill: false,
                      data: lowestConfidenceTrends.value,
                      allowDecimalTicksY: true,
                      labelValues: lowestLabelValues.value
                    }, null, 8, ["reportId", "data", "labelValues"])
                  ]),
                  _: 1
                }, 8, ["dataEmpty", "loadedData", "loadingError"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(Report, {
                  title: "Highest Confidence Trend",
                  dataEmpty: isDataEmpty(highestConfidenceTrends.value),
                  loadedData: loadedData.value,
                  loadingError: loadingError.value,
                  tooltipText: "A trend showing the average confidence score of the highest rated intents over time"
                }, {
                  chart: _withCtx(({ reportId }) => [
                    _createVNode(LineChart, {
                      class: "chart",
                      reportId: reportId,
                      fill: false,
                      data: highestConfidenceTrends.value,
                      allowDecimalTicksY: true,
                      labelValues: highestLabelValues.value
                    }, null, 8, ["reportId", "data", "labelValues"])
                  ]),
                  _: 1
                }, 8, ["dataEmpty", "loadedData", "loadingError"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})